// src/components/FlaticonIcon.js
import React from 'react';
import PropTypes from 'prop-types';

// Import your three SVGs as React components (SVGR)
/** @see CRA’s default SVGR setup */
import { ReactComponent as GovernmentBudgetIcon } from '../assets/flaticon/custom-svg/government-budget.svg';
import { ReactComponent as SmartContractIcon }   from '../assets/flaticon/custom-svg/smart-contract.svg';
import { ReactComponent as HandshakeDealLoanIcon }   from '../assets/flaticon/custom-svg/handshake-deal-loan.svg';
import { ReactComponent as PortfolioIcon }   from '../assets/flaticon/custom-svg/portfolio.svg';
import { ReactComponent as BriefcaseIcon }   from '../assets/flaticon/custom-svg/briefcase.svg';
import { ReactComponent as BriefcaseBlankIcon }   from '../assets/flaticon/custom-svg/briefcase-blank.svg';
import { ReactComponent as MasterPlanIcon }   from '../assets/flaticon/custom-svg/master-plan.svg';
import { ReactComponent as AssessmentIcon }   from '../assets/flaticon/custom-svg/assessment.svg';
import { ReactComponent as DescriptionAltIcon }   from '../assets/flaticon/custom-svg/description-alt.svg';
import { ReactComponent as AlbumCollectionAltIcon }   from '../assets/flaticon/custom-svg/album-collection.svg';
import { ReactComponent as BoxIcon }   from '../assets/flaticon/custom-svg/box.svg';
import { ReactComponent as AuditIcon }   from '../assets/flaticon/custom-svg/audit.svg';




const ICONS = {
  'government-budget': GovernmentBudgetIcon,
  'smart-contract':    SmartContractIcon,
  'handshake-deal-loan': HandshakeDealLoanIcon,
  'portfolio':  PortfolioIcon,
  'briefcase': BriefcaseIcon,
  'briefcase-blank': BriefcaseBlankIcon,
  'master-plan': MasterPlanIcon,
  'assessment': AssessmentIcon,
  'description-alt': DescriptionAltIcon,
  'album-collection': AlbumCollectionAltIcon,
  'box': BoxIcon,
  'audit': AuditIcon,
};

/**
 * FlaticonIcon renders one of your SVG icons inline so you can
 * fully control its size and color via props or CSS.
 *
 * @param {string} icon       – one of 'government-budget' | 'smart-contract' | 'contract'
 * @param {number|string} size – number→px or CSS unit string (default 20)
 * @param {string} color      – CSS fill color (default 'currentColor')
 * @param {string} className  – extra CSS classes
 * @param {...any} rest       – other <svg> props
 */
export default function FlaticonIcon({
  icon,
  size = 20,
  color = 'currentColor',
  className = '',
  ...rest
}) {
  const Svg = ICONS[icon];
  if (!Svg) {
    console.warn(`FlaticonIcon: no icon found for "${icon}"`);
    return null;
  }

  const dim = typeof size === 'number' ? `${size}px` : size;
  return (
    <Svg
      width={dim}
      height={dim}
      fill={color}
      className={className}
      {...rest}
    />
  );
}

FlaticonIcon.propTypes = {
  icon:      PropTypes.oneOf(['government-budget','smart-contract','handshake-deal-loan','portfolio', 'briefcase', 'briefcase-blank', 'master-plan', 'assessment', 'description-alt', 'album-collection', 'box', 'audit']).isRequired,
  size:      PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  color:     PropTypes.string,
  className: PropTypes.string,
};
